import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/css';
import type { ComponentProps } from 'react';
import type { DataTable } from '@verclam/ui-kit';

/** Styles shared by the cost tables: the Total row, and the audio / document header families. */
const costTableStyles = Object.freeze({
	/** Total row: recessed surface, ruled off from the rows by an ink line. */
	pt: {
		footerCell: {
			style: {
				backgroundColor: theme.aiCosts.totalRow.background,
				borderTop: `1.5px solid ${theme.aiCosts.totalRow.rule}`,
			},
		},
	} satisfies ComponentProps<typeof DataTable>['pt'],
	audioHeader: css`
		background-color: ${theme.aiCosts.audio.surface};
		color: ${theme.aiCosts.audio.ink};
	`,
	documentsHeader: css`
		background-color: ${theme.aiCosts.documents.surface};
		color: ${theme.aiCosts.documents.ink};
	`,
});

export default costTableStyles;
